<template>
  <section
    class="inner-page-main"
    :class="{
      'content-margin':
        !_.get(contentData, 'data.list[0].content.tabs[0]') &&
        _.get(contentData, 'conf.conf[0]') != 'layout2' &&
        _.get(contentData, 'data.list[0].images[0].devices'),
    }"
  >
    <div
      class="inner-page-top"
      :class="_.get(contentData, 'data.list[0].images[0]') ? 'expanded' : ''"
    >
      <div class="container-2 fade-up" v-in-viewport.once>
        <h1 class="font-55 f-light">
          {{ _.get(contentData, 'data.list[0].title') }}
        </h1>

        <div
          v-if="
            _.get($store.state.main.selected_menu, 'routeParams.singleview') &&
              _.get(contentData, 'data.list[0].organisation')
          "
          class="aditional-text"
        >
          {{ _.get(contentData, 'data.list[0].organisation') }}
        </div>
        <div
          v-if="_.get($store.state.main.selected_menu, 'routeParams.singleview')"
          class="text"
          v-html="_.get(contentData, 'data.list[0].content')"
        ></div>
        <template v-for="(item, index) in _.get(contentData, 'data.list[0].files')">
          <div
            class="file-download"
            :key="index"
            v-if="_.get($store.state.main.selected_menu, 'routeParams.singleview')"
          >
            <p class="font-16 title">{{ _.get(item, 'title') }}</p>
            <div class="download-buttons">
              <!-- :class="true ? 'disabled' : ''" -->
              <div class="download-box pointer" @click="downloadWithVueResource(item)">
                <IconComponent name="download-arrow" />
                <p class="download-lang">{{ $fn.tr('Download') }}</p>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="_.get($store.state.main.selected_menu, 'routeParams.singleview')"
        class="share-with-friends container-2"
      >
        <p class="font-16">{{ $fn.tr('Share With Friend') }}</p>
        <div class="share-box" key="share-options">
          <template v-for="(icon, index) in getShareLinks">
            <div
              class="share-icon pointer"
              v-html="icon.svg"
              :key="index"
              @click.stop="openSharePopup(icon.url)"
              target="_blank"
              :href="icon.url"
            ></div>
          </template>
        </div>
      </div>

      <!-- _.get(contentData, 'conf.conf[0]') == 'layout2' ? 'img-content' : ''-->

      <div
        class="expanded-container  fade-up"
        :class="{
          'img-content':
            _.get(contentData, 'conf.conf[0]') == 'layout2' ||
            !_.get(contentData, 'data.list[0].content.tabs[0]'),
        }"
        v-in-viewport.once
        v-if="_.get(contentData, 'data.list[0].images[0].devices')"
      >
        <div class="img-box">
          <picture>
            <source
              class="img-absolute scale"
              media="(max-width: 767px)"
              :srcset="_.get(contentData, 'data.list[0].images[0].devices.mobile')"
            />
            <source
              class="img-absolute scale"
              media="(max-width: 1023px)"
              :srcset="_.get(contentData, 'data.list[0].images[0].devices.tablet')"
            />
            <img
              class="img-absolute scale"
              :src="_.get(contentData, 'data.list[0].images[0].devices.desktop')"
              :alt="_.get(contentData, 'data.list[0].images[0].title.title')"
            />
          </picture>
        </div>
      </div>
      <div
        class="container-2 fade-up"
        v-in-viewport.once
        v-if="
          _.get(contentData, 'data.list[0].content.tabs[0]') &&
            _.get(contentData, 'conf.conf[0]') != 'layout2'
        "
      >
        <div class="content-with-img">
          <div
            v-if="_.get(contentData, 'data.list[0].content.tabs[0].content')"
            class="text"
            v-html="_.get(contentData, 'data.list[0].content.tabs[0].content')"
          ></div>
        </div>
      </div>
    </div>
    <template v-if="_.get(contentData, 'conf.conf[0]') == 'layout2'">
      <div class="container-2">
        <div
          class="no-bg-expanded fade-up"
          :class="_.get(contentData, 'data.list[0].images[0].devices') ? 'space-img' : ''"
          v-in-viewport.once
          v-if="_.get(contentData, 'data.list[0].content.tabs[0]')"
        >
          <div class="content-with-no-bg">
            <div
              v-if="_.get(contentData, 'data.list[0].content.tabs[0].content')"
              class="text"
              v-html="_.get(contentData, 'data.list[0].content.tabs[0].content')"
            ></div>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import IconComponent from '../IconComponent.vue';
export default {
  props: ['contentData'],
  components: {
    IconComponent,
  },
  data() {
    return {};
  },
  computed: {
    getShareLinks() {
      let socialList = [];

      let socialSvgs = _.get(this.$store.state.main.indx, 'widgets.social_icons');

      let uri = encodeURI(
        window.location.protocol +
          '//' +
          window.location.host +
          '' +
          this.$route.path +
          window.location.search
      );

      if (!socialSvgs) return socialList;
      for (let i in socialSvgs) {
        socialList.push({
          svg: socialSvgs[i].svg,
          url: socialSvgs[i].url + uri,
        });
      }

      return socialList;
    },
  },
  methods: {
    openSharePopup(url) {
      let winWidth = 650;
      let winHeight = 350;
      let winTop = 200;
      let winLeft = screen.width / 2 - winWidth / 2;
      window.open(
        url,
        'sharer',
        'top=' +
          winTop +
          ',left=' +
          winLeft +
          ',toolbar=0,status=0,width=' +
          winWidth +
          ',height=' +
          winHeight
      );
    },
  },
};
</script>

<style lang="scss">
.inner-page-top {
  background: var(--thirdy-tranparent);
  padding: 144px 0;
  @media (max-width: 1599px) {
    padding: 89px 0;
  }
  &.expanded {
    position: relative;
    padding-bottom: 0;
    margin-bottom: 144px;
    @media (max-width: 1599px) {
      margin-bottom: 89px;
    }
    @media (max-width: 1023px) {
      padding: 55px 0;
    }
    @media (max-width: 1023px) {
      margin-bottom: 55px;
      padding: 21px 0 0;
    }
    @media (max-width: 1023px) {
      margin-bottom: 34px;
    }
    .img-content {
      height: 305px;
      @media (max-width: 1599px) {
        height: 232px;
      }
      @media (max-width: 1365px) {
        height: 162px;
      }
      @media (max-width: 1023px) {
        height: 100%;
      }
    }
    .img-box {
      width: 100%;
      height: 610px;
      margin-top: 86px;
      position: relative;
      transform: translateY(-30px);
      @media (max-width: 1599px) {
        height: 464px;
      }
      @media (max-width: 1439px) {
        height: 439px;
      }
      @media (max-width: 1365px) {
        height: 312px;
      }
      @media (max-width: 1023px) {
        transform: translateY(0);
        margin-top: 55px;
        height: 375px;
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .content-with-img {
      margin-top: 116px;
      padding-bottom: 80px;
      @media (max-width: 1023px) {
        margin-top: 100px;
        padding-bottom: 55px;
      }
      @media (max-width: 767px) {
        padding-bottom: 34px;
      }
      h2 {
        margin-bottom: 34px;
        color: var(--bonus-txt);
        @media (max-width: 767px) {
          font-size: 34px;
          margin-bottom: 21px;
        }
      }
      h3 {
        color: var(--bonus-txt);
        width: fit-content;
        margin-bottom: 55px;
        @media (max-width: 1023px) {
          margin-bottom: 34px;
        }
      }
      h4 {
        color: var(--bonus-txt);
        width: fit-content;
        margin-bottom: 55px;
        line-height: 51px;
        @media (max-width: 1023px) {
          line-height: 41px;
          font-size: 21px;
        }
        @media (max-width: 767px) {
          margin-bottom: 34px;
        }
      }
      .text {
        margin-bottom: 0;
      }
    }
  }
  h1 {
    color: var(--bonus-txt);
    @media (max-width: 1365px) {
      font-size: 34px;
    }
  }
  .aditional-text {
    color: var(--primary-txt);
    margin-top: 20px;
  }
  .share-with-friends {
    display: flex;
    align-items: center;
    p {
      color: var(--bonus-txt);
    }
    .share-box {
      display: flex;
      .share-icon {
        margin-left: 10px;
      }
    }
  }
}
.space-img {
  margin-top: 344px;
  @media (max-width: 1599px) {
    margin-top: 255px;
  }
  @media (max-width: 1365px) {
    margin-top: 180px;
  }
  @media (max-width: 1023px) {
    margin-top: 55px;
  }
  .content-with-no-bg {
    margin-top: 116px;
    padding-bottom: 80px;
    @media (max-width: 1023px) {
      margin-top: 55px;
      padding-bottom: 55px;
    }
    @media (max-width: 767px) {
      padding-bottom: 34px;
    }
    .text {
      margin-bottom: 0;
    }
  }
}
.inner-page-main {
  &.content-margin {
    margin-bottom: 449px;
    @media (max-width: 1599px) {
      margin-bottom: 321px;
    }
    @media (max-width: 1365px) {
      margin-bottom: 241px;
    }
    @media (max-width: 1023px) {
      margin-bottom: 0;
    }
  }
  .text {
    color: var(--bonus-txt);
    margin: 34px 0 55px;

    img {
      width: calc(100% + 300px);
      height: unset;
      margin-left: -160px;
      @media (max-width: 1023px) {
        margin-left: 0px;
        width: 100%;
      }
    }
    p {
      margin-bottom: 30px;
      line-height: 31.5px;
    }
    p {
      color: var(--bonus-txt);
    }
    h2 {
      margin-bottom: 34px;
      color: var(--bonus-txt);
      font-size: 55px;
      @media (max-width: 767px) {
        font-size: 34px;
        margin-bottom: 21px;
      }
    }
    h3 {
      color: var(--bonus-txt);
      width: fit-content;
      font-size: 34px;
      margin-bottom: 55px;
      @media (max-width: 1023px) {
        margin-bottom: 34px;
      }
    }
    h4 {
      color: var(--bonus-txt);
      width: fit-content;
      margin-bottom: 55px;
      font-size: 34px;
      line-height: 51px;
      @media (max-width: 1023px) {
        line-height: 41px;
        font-size: 21px;
      }
      @media (max-width: 767px) {
        margin-bottom: 34px;
      }
    }
  }
  .file-download {
    background: var(--white-bg);
    padding: 30px 60px 30px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    position: relative;
    margin: 34px 0;
    @media (max-width: 1365px) {
      padding: 30px 20px;
    }
    @media (max-width: 1023px) {
      flex-direction: column;
      align-items: flex-start;
      padding: 15px 20px;
    }
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: -30px;
      max-height: 25px;
      height: 100%;
      width: 2px;
      border-radius: 5px;
      background: var(--red);
      transform: translateY(-50%);
      transition: 0.4s ease-in-out;
      @media (max-width: 1023px) {
        display: none;
      }
    }
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    p {
      color: var(--bonus-txt);
    }
    .title {
      max-width: 70%;
      margin-right: 30px;
      @media (max-width: 1023px) {
        max-width: 100%;
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
    .download-buttons {
      display: flex;
      align-items: center;
      .download-box {
        display: flex;
        align-items: center;
        color: var(--bonus-txt);
        &.disabled {
          opacity: 0.3;
          pointer-events: none;
          cursor: not-allowed;
        }
        &:not(:last-child) {
          margin-right: 55px;
        }
        .download-lang {
          text-decoration: underline;
          text-decoration-color: var(--bonus-txt);
        }
        svg {
          margin-right: 10px;
        }
      }
    }
    &:hover {
      background: var(--secondary);
      &::before {
        content: '';
        max-height: 150px;
        background: var(--secondary);
        transition: 0.4s ease-in-out;
      }
      p {
        color: var(--white-txt);
      }
      .download-buttons {
        .download-box {
          .download-lang {
            text-decoration: underline;
            text-decoration-color: var(--white-txt);
          }
          svg {
            path {
              fill: var(--white-txt) !important;
            }
          }
        }
      }
    }
  }
}
</style>
